import { useEffect, useState } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';

import { CookieConsentContext } from './cookie-consent-context';
import { pluginConfig } from './cookie-consent-config';

import 'vanilla-cookieconsent/dist/cookieconsent.css';
import './cookie-consent-custom.css';
import { CookieConsentConfig } from 'vanilla-cookieconsent';

interface CookieConsentProviderProps {
  children: React.ReactNode;
}

export const CookieConsentProvider = ({
  children,
}: CookieConsentProviderProps) => {
  const [cc, setCc] = useState<typeof CookieConsent | null>(null);

  useEffect(() => {
    // Skip cookie consent for embedded pages (iframes with their own auth)
    if (window.location.pathname.startsWith('/embed/')) return;

    try {
      CookieConsent.run(pluginConfig as CookieConsentConfig);
      setCc(CookieConsent);
    } catch (error) {
      console.error('Failed to initialize cookie consent:', error);
    }
  }, []);

  return (
    <CookieConsentContext.Provider value={{ cc }}>
      {children}
    </CookieConsentContext.Provider>
  );
};
